/* global axios */

import ApiClient from './ApiClient';

class KefubaoPhrasesAPI extends ApiClient {
  constructor() {
    super('kefubao_phrases', { accountScoped: true });
  }

  get({ searchKey } = {}) {
    const url = searchKey
      ? `${this.url}?search=${encodeURIComponent(searchKey)}`
      : this.url;
    return axios.get(url);
  }

  create(data) {
    return axios.post(this.url, { kefubao_phrase: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { kefubao_phrase: data });
  }
}

export default new KefubaoPhrasesAPI();
